module.exports = __webpack_public_path__ + "static/img/describe.ef7dbd7.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/index1/describe.png
// module id = 7bB7
// module chunks = 7